document.querySelectorAll("[data-encode-email]").forEach((element) => {
  const address = element.dataset.encodeAddr;
  const domain = element.dataset.encodeDomain || "tarifhaus.de";
  element.innerHTML = `${address}@${domain}`;
});
